import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Header } from 'semantic-ui-react';
import { removeShownPopupMessage } from '../../store/reducers/ui/actions';
import Button from '../elements/Button';
import { isNullOrUndefined } from '../../utils/siteFunctions';

const PopupMessages = () => {
	/// Hooks
	const dispatch = useDispatch();

	/// Global State
	const popupMessage = useSelector(state => state.ui.popupMessages.length > 0 ? state.ui.popupMessages[state.ui.popupMessages.length - 1] : undefined);

	/// Events
	const handleClosePopupMessageModal = e => {
		dispatch(removeShownPopupMessage());
	};

	/// Render
	return (
		<>
			<Modal
				closeIcon
				onClose={handleClosePopupMessageModal}
				open={!isNullOrUndefined(popupMessage)}
			>
				<Header icon={popupMessage?.icon} content={popupMessage?.title} />
				<Modal.Content>
					{popupMessage?.message}
				</Modal.Content>
				<Modal.Actions>
					{popupMessage?.buttons.length === 0 ? (
						<Button secondary onClick={handleClosePopupMessageModal}>
							OK
						</Button>
					) : (
						popupMessage?.buttons.map((x, index) => (
							<Button key={index} primary={x.primary} secondary={x.secondary} onClick={e => { x.onClick && x.onClick(e); handleClosePopupMessageModal(e); }}>{x.text}</Button>
						))
					)
					}
				</Modal.Actions>
			</Modal>
		</>
	);
};

export default PopupMessages;